import { ElementRef, EventEmitter } from "@angular/core";
import { AccountService } from '../../../core/auth/account.service';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SessionService } from '../../session/session.service';
import { SessionControlComponent } from '../../session/session-chat-coach/session-control.component/session-control.component';
import { MessageService } from '../../message/message.service';
import { SessionStorageService } from "ngx-webstorage";
import { TranslateService } from "@ngx-translate/core";
import { CoachDetailsService } from '../../slot/coach-details.service';
import { Session } from '../../../shared/model/session.model';
import { DataSharingConsentService } from '../../data-sharing-consent/data-sharing-consent.service';
import { ZoomService } from '../zoom.service';
import { OrganizationResourcesComponent } from '../../organization-resources/organization-resources.component';
import { LeaveNumberModalComponent } from '../../login/leave-number-modal.component';
import { UserInteractionService } from '../../user-interaction/user-interaction.service';
import { OrganizationResourceService } from '../../../admin/organization-resource/organization-resource.service';
import { TrackerService } from '../../../core/tracker/tracker.service';
import { JhiAlertService, JhiEventManager } from '../../../ng-jhipster/service';
import * as i0 from "@angular/core";
import * as i1 from "../../message/message.service";
import * as i2 from "../../../ng-jhipster/service";
import * as i3 from "ngx-webstorage";
import * as i4 from "../../session/session.service";
import * as i5 from "@ng-bootstrap/ng-bootstrap";
import * as i6 from "@ngx-translate/core";
import * as i7 from "../../../core/auth/account.service";
import * as i8 from "../../slot/coach-details.service";
import * as i9 from "../../data-sharing-consent/data-sharing-consent.service";
import * as i10 from "../zoom.service";
import * as i11 from "../../user-interaction/user-interaction.service";
import * as i12 from "../../../admin/organization-resource/organization-resource.service";
import * as i13 from "../../../core/tracker/tracker.service";
import * as i14 from "@fortawesome/angular-fontawesome";
import * as i15 from "../../../ng-jhipster/language/jhi-translate.directive";
import * as i16 from "@angular/common";
import * as i17 from "../audio-toggler/audio-toggler.component";
import * as i18 from "../video-toggler/video-toggler.component";
import * as i19 from "../../../shared/resources-for-help/resources-for-help.component";
const _c0 = ["resourcesForHelpModal"];
const _c1 = ["askToShareOrganizationResources"];
function CoachSessionControlLowerMobileComponent_li_12_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 21);
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("color", ctx_r8.minutesLeft > 10 || ctx_r8.session.ended ? "#7CBFAE" : "#44A38B");
} }
function CoachSessionControlLowerMobileComponent_li_12_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 7);
    i0.ɵɵlistener("click", function CoachSessionControlLowerMobileComponent_li_12_Template_li_click_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.extendSessionByTenMinutes(); });
    i0.ɵɵtemplate(1, CoachSessionControlLowerMobileComponent_li_12_span_1_Template, 1, 2, "span", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.session.minutesLeftToSessionStart <= 0);
} }
const _c2 = function (a0) { return { "dropdown-item-disabled": a0 }; };
function CoachSessionControlLowerMobileComponent_li_13_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 22);
    i0.ɵɵlistener("click", function CoachSessionControlLowerMobileComponent_li_13_Template_li_click_0_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.displayOrganisationResourcesModal(); });
    i0.ɵɵelement(1, "span", 23);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c2, !ctx_r1.isCoachAllowedToSeeOrganizationResources));
} }
function CoachSessionControlLowerMobileComponent_ng_template_22_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵelementStart(1, "div", 25);
    i0.ɵɵelementStart(2, "fa-icon", 26);
    i0.ɵɵlistener("click", function CoachSessionControlLowerMobileComponent_ng_template_22_div_0_Template_fa_icon_click_2_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(2); return ctx_r15.dismissAll(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 27);
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵelement(5, "h3", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵelement(7, "p", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 30);
    i0.ɵɵelementStart(9, "button", 31);
    i0.ɵɵlistener("click", function CoachSessionControlLowerMobileComponent_ng_template_22_div_0_Template_button_click_9_listener() { i0.ɵɵrestoreView(_r16); const ctx_r17 = i0.ɵɵnextContext(2); return ctx_r17.endSession(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "button", 32);
    i0.ɵɵlistener("click", function CoachSessionControlLowerMobileComponent_ng_template_22_div_0_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r16); const ctx_r18 = i0.ɵɵnextContext(2); return ctx_r18.dismissAll(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function CoachSessionControlLowerMobileComponent_ng_template_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵtemplate(0, CoachSessionControlLowerMobileComponent_ng_template_22_div_0_Template, 11, 0, "div", 24);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r3.ended);
} }
function CoachSessionControlLowerMobileComponent_ng_template_24_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵelementStart(1, "div", 25);
    i0.ɵɵelementStart(2, "fa-icon", 34);
    i0.ɵɵlistener("click", function CoachSessionControlLowerMobileComponent_ng_template_24_Template_fa_icon_click_2_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(); return ctx_r20.dismissAll(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 35);
    i0.ɵɵelementStart(4, "resources-for-help", 36);
    i0.ɵɵlistener("resourceSelected", function CoachSessionControlLowerMobileComponent_ng_template_24_Template_resources_for_help_resourceSelected_4_listener($event) { i0.ɵɵrestoreView(_r21); const ctx_r22 = i0.ɵɵnextContext(); return ctx_r22.onResourceSelected($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("user", ctx_r5.session.user);
} }
function CoachSessionControlLowerMobileComponent_ng_template_26_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵelementStart(1, "div", 25);
    i0.ɵɵelementStart(2, "fa-icon", 26);
    i0.ɵɵlistener("click", function CoachSessionControlLowerMobileComponent_ng_template_26_Template_fa_icon_click_2_listener() { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(); return ctx_r24.dismissAll(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 38);
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵelement(5, "h3", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "br");
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵelement(8, "p", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 30);
    i0.ɵɵelementStart(10, "button", 41);
    i0.ɵɵlistener("click", function CoachSessionControlLowerMobileComponent_ng_template_26_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r25); const ctx_r26 = i0.ɵɵnextContext(); return ctx_r26.dismissAll(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "button", 42);
    i0.ɵɵlistener("click", function CoachSessionControlLowerMobileComponent_ng_template_26_Template_button_click_11_listener() { i0.ɵɵrestoreView(_r25); const ctx_r27 = i0.ɵɵnextContext(); return ctx_r27.askToShare(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
export class CoachSessionControlLowerMobileComponent extends SessionControlComponent {
    constructor(messageService, alertService, sessionStorage, sessionService, modalService, translate, accountService, coachDetailsService, dataSharingConsentService, eventManager, zoomService, userInteractionService, ngbModal, organizationResourceService, trackerService) {
        super(messageService, alertService, sessionStorage, sessionService, modalService, translate, accountService, coachDetailsService, trackerService);
        this.messageService = messageService;
        this.alertService = alertService;
        this.sessionStorage = sessionStorage;
        this.sessionService = sessionService;
        this.modalService = modalService;
        this.translate = translate;
        this.accountService = accountService;
        this.coachDetailsService = coachDetailsService;
        this.dataSharingConsentService = dataSharingConsentService;
        this.eventManager = eventManager;
        this.zoomService = zoomService;
        this.userInteractionService = userInteractionService;
        this.ngbModal = ngbModal;
        this.organizationResourceService = organizationResourceService;
        this.trackerService = trackerService;
        this.onStopCall = new EventEmitter();
        this.isCoachAllowedToSeeOrganizationResources = false;
        this.above = 'above';
    }
    ngOnInit() {
        super.ngOnInit();
        console.log(this.session);
        if (this.session != null) {
            this.coachee = this.session.user;
            this.organizationResourceService.areAnyOrganizationResourcesExistByUserIdAndLangKey(this.session.user.id, this.session.langKey).subscribe(res2 => {
                this.areAnyOrganizationResourcesExistForUser = res2.body;
                this.checkIsCoachAllowedToSeeOrganizationResources();
            });
            this.checkIsCoachAllowedToSeeOrganizationResources();
        }
        else {
            console.log("Session can not be retrieved.");
        }
        this.eventManager.subscribe('userInteractionFinishedForConsentToShareOrganizationResource', () => {
            this.checkIsCoachAllowedToSeeOrganizationResources();
        });
    }
    checkIsCoachAllowedToSeeOrganizationResources() {
        this.dataSharingConsentService.find("ORGANIZATION_RESOURCE" /* ORGANIZATION_RESOURCE */, this.coachee.id).subscribe(dataSharingConsent => {
            if (dataSharingConsent === null || dataSharingConsent === void 0 ? void 0 : dataSharingConsent.body.consented) {
                this.isCoachAllowedToSeeOrganizationResources = true;
            }
        });
    }
    stopCall() {
        this.onStopCall.emit();
    }
    sendSelfScan() {
        this.messageService.startWellbeingScan(this.session.user.id, this.session.id).subscribe(() => this.alertService.info('inukaNgApp.session.selfScanSent'), () => console.log('fail'));
    }
    displayResourcesModal() {
        this.modalService.open(this.resourcesForHelpModal, { windowClass: 'resources-for-help-modal' });
    }
    displayOrganisationResourcesModal() {
        if (this.isCoachAllowedToSeeOrganizationResources) {
            const modalRef = this.modalService.open(OrganizationResourcesComponent, { size: "lg", centered: true });
            modalRef.componentInstance.isPopup = true;
            modalRef.componentInstance.userId = this.session.user.id;
            modalRef.componentInstance.organizationResourcesModalRef = modalRef;
        }
        else {
            this.modalService.open(this.askToShareOrganizationResources, { size: "md", centered: true });
        }
    }
    askToShare() {
        this.userInteractionService.startUserInteraction("CONSENT_TO_SHARE_ORGANIZATION_RESOURCE", this.session.user.id).subscribe(res => {
            console.log(res);
            this.dismissAll();
            const modalRef = this.ngbModal.open(LeaveNumberModalComponent, { size: 'md', centered: true });
            modalRef.componentInstance.leaveNumberModalRef = modalRef;
            modalRef.componentInstance.displayNLHelpHeader = false;
            modalRef.componentInstance.errorMessage = "sessionChat.header.sent";
        });
    }
}
CoachSessionControlLowerMobileComponent.ɵfac = function CoachSessionControlLowerMobileComponent_Factory(t) { return new (t || CoachSessionControlLowerMobileComponent)(i0.ɵɵdirectiveInject(i1.MessageService), i0.ɵɵdirectiveInject(i2.JhiAlertService), i0.ɵɵdirectiveInject(i3.SessionStorageService), i0.ɵɵdirectiveInject(i4.SessionService), i0.ɵɵdirectiveInject(i5.NgbModal), i0.ɵɵdirectiveInject(i6.TranslateService), i0.ɵɵdirectiveInject(i7.AccountService), i0.ɵɵdirectiveInject(i8.CoachDetailsService), i0.ɵɵdirectiveInject(i9.DataSharingConsentService), i0.ɵɵdirectiveInject(i2.JhiEventManager), i0.ɵɵdirectiveInject(i10.ZoomService), i0.ɵɵdirectiveInject(i11.UserInteractionService), i0.ɵɵdirectiveInject(i5.NgbModal), i0.ɵɵdirectiveInject(i12.OrganizationResourceService), i0.ɵɵdirectiveInject(i13.TrackerService)); };
CoachSessionControlLowerMobileComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CoachSessionControlLowerMobileComponent, selectors: [["coach-session-control-lower-mobile"]], viewQuery: function CoachSessionControlLowerMobileComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.resourcesForHelpModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.askToShareOrganizationResources = _t.first);
    } }, inputs: { session: "session" }, outputs: { onStopCall: "onStopCall" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 28, vars: 4, consts: [[1, "olha-theme"], [1, "d-flex", "align-items-center", "justify-content-around", "nav-bar"], [1, "box-button", "box-button-dropdown", "d-flex", "align-items-center", "justify-content-center", "m-1"], ["ngbDropdown", "", "placement", "top-left", 1, "d-inline-block", "text-dark", "align-middle"], ["ngbDropdownToggle", "", "href", "javascript:void(0);", 1, "language-anchor"], ["icon", "ellipsis-h", 2, "font-size", "18px"], ["ngbDropdownMenu", "", 1, "dropdown-menu"], [1, "dropdown-item", "p-0", 3, "click"], ["jhiTranslate", "sessionChat.button.sendSelfScan", 1, "item-bold", "light-green", "dropdown-item", "p-0"], ["jhiTranslate", "sessionChat.button.resources", 1, "item-bold", "light-green", "dropdown-item", "p-0"], ["class", "dropdown-item p-0", 3, "click", 4, "ngIf"], ["class", "dropdown-item p-0", 3, "ngClass", "click", 4, "ngIf"], ["showLabel", "false", 3, "tooltipPosition"], [1, "mr-2"], [1, "stop-button", 3, "click"], ["width", "22", "height", "22"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#stop-call"], ["endSessionModal", ""], ["resourcesForHelpModal", ""], ["askToShareOrganizationResources", ""], ["class", "item-bold light-green dropdown-item p-0", "id", "extend-session-btn", "jhiTranslate", "sessionChat.button.extendSession", 3, "color", 4, "ngIf"], ["id", "extend-session-btn", "jhiTranslate", "sessionChat.button.extendSession", 1, "item-bold", "light-green", "dropdown-item", "p-0"], [1, "dropdown-item", "p-0", 3, "ngClass", "click"], ["jhiTranslate", "sessionChat.button.organizationResources", 1, "item-bold", "light-green", "dropdown-item", "p-0"], ["class", "olha-theme", 4, "ngIf"], [1, "d-flex", "justify-content-end"], ["icon", "times-circle", 1, "mt-3", "mr-3", 2, "cursor", "pointer", 3, "click"], [1, "modal-body", "text-center"], ["jhiTranslate", "sessionChat.header.confirm"], ["jhiTranslate", "sessionChat.paragraph.end"], [1, "d-flex", "justify-content-center", "mt-4"], ["type", "button", "jhiTranslate", "sessionChat.button.end", 1, "btn", "btn-primary", "m-2", 3, "click"], ["type", "button", "jhiTranslate", "sessionChat.button.close", 1, "btn", "btn-secondary", "m-2", 3, "click"], [1, "olha-theme", "resources-content"], ["icon", "times-circle", 1, "mt-3", 2, "cursor", "pointer", 3, "click"], [1, "modal-body", "pt-0"], [3, "user", "resourceSelected"], [1, "olha-theme", "p-2", "pb-3"], [1, "modal-body", "text-center", "p-0"], ["jhiTranslate", "sessionChat.header.notShared"], ["jhiTranslate", "sessionChat.paragraph.askToShare"], ["type", "button", "jhiTranslate", "sessionChat.button.cancel", 1, "btn", "btn-secondary", "m-2", 3, "click"], ["type", "button", "jhiTranslate", "sessionChat.button.askToSee", 1, "btn", "btn-primary", "m-2", 3, "click"]], template: function CoachSessionControlLowerMobileComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "span", 3);
        i0.ɵɵelementStart(4, "a", 4);
        i0.ɵɵelementStart(5, "div", 2);
        i0.ɵɵelement(6, "fa-icon", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "ul", 6);
        i0.ɵɵelementStart(8, "li", 7);
        i0.ɵɵlistener("click", function CoachSessionControlLowerMobileComponent_Template_li_click_8_listener() { return ctx.sendSelfScan(); });
        i0.ɵɵelement(9, "span", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "li", 7);
        i0.ɵɵlistener("click", function CoachSessionControlLowerMobileComponent_Template_li_click_10_listener() { return ctx.displayResourcesModal(); });
        i0.ɵɵelement(11, "span", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(12, CoachSessionControlLowerMobileComponent_li_12_Template, 2, 1, "li", 10);
        i0.ɵɵtemplate(13, CoachSessionControlLowerMobileComponent_li_13_Template, 2, 3, "li", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div");
        i0.ɵɵelement(15, "audio-toggler", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div");
        i0.ɵɵelement(17, "video-toggler", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "div", 13);
        i0.ɵɵelementStart(19, "button", 14);
        i0.ɵɵlistener("click", function CoachSessionControlLowerMobileComponent_Template_button_click_19_listener() { return ctx.stopCall(); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(20, "svg", 15);
        i0.ɵɵelement(21, "use", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(22, CoachSessionControlLowerMobileComponent_ng_template_22_Template, 1, 1, "ng-template", null, 17, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(24, CoachSessionControlLowerMobileComponent_ng_template_24_Template, 5, 1, "ng-template", null, 18, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(26, CoachSessionControlLowerMobileComponent_ng_template_26_Template, 12, 0, "ng-template", null, 19, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵadvance(12);
        i0.ɵɵproperty("ngIf", ctx.session != null && ctx.session.started);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.areAnyOrganizationResourcesExistForUser);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("tooltipPosition", ctx.above);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("tooltipPosition", ctx.above);
    } }, directives: [i5.NgbDropdown, i5.NgbDropdownToggle, i14.FaIconComponent, i5.NgbDropdownMenu, i15.JhiTranslateDirective, i16.NgIf, i17.AudioTogglerComponent, i18.VideoTogglerComponent, i16.NgClass, i19.ResourcesForHelpComponent], styles: [".nav-bar[_ngcontent-%COMP%]{background:#f7eed2}.stop-button[_ngcontent-%COMP%]{font-family:Poppins,sans-serif;font-weight:400;width:40px;height:40px;background:var(--accent-2);color:#f7eed2;border-radius:8px;border:none !important;cursor:pointer}.box-button[_ngcontent-%COMP%]{font-family:Poppins,sans-serif;font-weight:400;width:50px;height:50px;color:#44a38b;background:#f7eed2;border-radius:8px;cursor:pointer}.box-button-toggle[_ngcontent-%COMP%]:active, .box-button-dropdown[_ngcontent-%COMP%]:hover, .box-button-toggle-active[_ngcontent-%COMP%]{color:#f7eed2;background:#44a38b}.dropdown-menu[_ngcontent-%COMP%]{padding:15px 25px;box-shadow:0px -2px 15px rgba(0,0,0,.14);border-radius:4px 4px 0 0;border:none;min-width:-moz-fit-content;min-width:fit-content;position:fixed}.dropdown-toggle[_ngcontent-%COMP%]:after{display:none !important}.dropdown-item-disabled[_ngcontent-%COMP%]{background-color:#fff;color:#7cbfae !important;font-weight:bold}.dropdown-item[_ngcontent-%COMP%]:hover, .dropdown-item-disabled[_ngcontent-%COMP%]:hover{background-color:#fff;color:#0a4a3a;text-decoration:underline}a[_ngcontent-%COMP%]{text-decoration:none}.item-bold[_ngcontent-%COMP%]{margin-bottom:15px;font-family:\"Poppins\",serif;font-style:normal;font-weight:700;font-size:14px;line-height:25px;color:#0a4a3a;cursor:pointer}.light-green[_ngcontent-%COMP%]{color:#44a38b !important}"] });
